import { getTreeViewSelectedItemsLabel } from "../../../../components";
import { ITreeItem } from "src/models";

export function getShortLabel(items: ITreeItem[]) {
  if (items.length === 1) {
    return items[0].label ?? "-";
  } else if (items.length > 1) {
    return getTreeViewSelectedItemsLabel(items);
  } else {
    return null;
  }
}

export function getFullLabel(items: ITreeItem[]) {
  if (items.length > 1) {
    return items
      .map((x) => x.label)
      .sort((a, b) => a.localeCompare(b))
      .join(", ");
  }

  return null;
}
